import { createContext } from "@smartsheet/lodestar-utils";
export const LodestarCoreTheme = createContext("light", "LodestarCoreTheme");
//# sourceMappingURL=LodestarCoreTheme.js.map